// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Checkbox$OrcaPaymentPage from "./Checkbox.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as CustomPaymentMethodsConfig$OrcaPaymentPage from "../Hooks/CustomPaymentMethodsConfig.bs.js";

function SaveDetailsCheckbox(props) {
  var setIsChecked = props.setIsChecked;
  var showPaymentMethodsScreen = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var customMessageForCardTerms = match.customMessageForCardTerms;
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var customMessageConfig = CustomPaymentMethodsConfig$OrcaPaymentPage.useCustomPaymentMethodConfigs("card", "debit");
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var handleChange = function (value) {
    LoggerUtils$OrcaPaymentPage.logInputChangeInfo("saveDetails", loggerState);
    setIsChecked(function (param) {
          return value;
        });
  };
  var customMessageConfigValue = Core__Option.getOr(customMessageConfig.value, "");
  var saveCardCheckboxLabel = showPaymentMethodsScreen ? localeString.saveCardDetails : (
      customMessageConfigValue.length > 0 ? customMessageConfigValue : (
          customMessageForCardTerms.length > 0 ? customMessageForCardTerms : localeString.cardTerms(match.business.name)
        )
    );
  return React.createElement(Checkbox$OrcaPaymentPage.make, {
              isChecked: props.isChecked,
              onChange: handleChange,
              label: saveCardCheckboxLabel,
              ariaLabelChecked: "Deselect to avoid saving card details",
              ariaLabelUnchecked: "Select to save card details"
            });
}

var make = SaveDetailsCheckbox;

export {
  make ,
}
/* react Not a pure module */
